import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fill="#D0D6CE"
      fillRule="evenodd"
      d="M4.842 14.029a5.5 5.5 0 0 1 10.266-2.14q.138-.01.277-.01a4.103 4.103 0 1 1 0 8.208h-9.8a3.074 3.074 0 0 1-.743-6.058"
      clipRule="evenodd"
    />
    <path
      fill="#EDB326"
      d="M21.216 8.625c.386-.133.838.139.744.536a5.1 5.1 0 0 1-2.033 2.998 5.98 5.98 0 0 0-3.778-1.759 7.37 7.37 0 0 0-4.258-2.642 5.11 5.11 0 0 1 3.92-4.745c.398-.095.67.358.537.744a3.83 3.83 0 0 0 4.868 4.868"
    />
  </>
);

const Weather27Colored = Icon('weather-27-colored', svgContents);

export default Weather27Colored;
